import React from 'react';

export default function VideoPlaceholder() {
    return (
        <div
            data-aos='zoom-in'
            className='videoCard card-layout placeholder-glow'
        >
            {/* Thumbnail Placeholder */}
            <div className='thumbnail placeholder col-12' style={{ height: '180px', backgroundColor: '#e0e0e0' }}></div>

            {/* Video Info Placeholder */}
            <div className='video-info mt-3'>
                <p className='placeholder col-8'></p>
                
                <div className='video-stats d-flex justify-content-between'>
                    <p className='placeholder col-4'></p>
                    
                </div>
            </div>
        </div>
    );
}